import { Hexagon } from "lucide-react";
import { useLanguage } from "@/i18n";

export default function Ticker() {
  const { t } = useLanguage();
  const items = t("ticker");
  const doubled = [...items, ...items];

  return (
    <div data-testid="tech-ticker-container" className="relative overflow-hidden border-y border-emerald-500/10 bg-[#050d0a] py-5">
      <div className="ticker-track flex w-max items-center gap-10 whitespace-nowrap">
        {doubled.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-display text-lg italic tracking-wide text-slate-400">{item}</span>
            <Hexagon className="h-3 w-3 text-emerald-500/60" fill="currentColor" />
          </span>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#030706] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#030706] to-transparent" />
    </div>
  );
}
